import axios from 'axios'
import React, { useState, useEffect } from 'react'

import parse from 'html-react-parser'

import disimIcon from '../../assets/images/dis-im.png'
import apiUrl from '../../services/apiUrl'
import '../../assets/css/treatment/treatment.scoped.css'


function TreatmentHead(props) {


    const [diseaseInfo, setdiseaseInfo] = useState({})
    const [showReadMore, setshowReadMore] = useState(false)
    const [diseaseDisc, setdiseaseDisc] = useState({})

    useEffect(() => {
        getDiseaseInfo()
        getDiseaseDiscription()

    }, [])


    const getDiseaseInfo = async () => {
        try {
            var response = await axios.post(apiUrl.getTreatmentDises, { treatment_id: props.id })
            if (response?.data?.status && response?.data?.data?.diseases) {
                setdiseaseInfo(response.data.data.diseases)
            }
        } catch (error) {
            console.log(error)

        }
    }

    const getDiseaseDiscription = async () => {
        try {
            var response = await axios.post(apiUrl.getTreatmentDiseasesDiscription, { treatment_id: props.id })
            if (response?.data?.status && response.data.data.description) {
                setdiseaseDisc(response.data.data.description)
            }
        } catch (error) {
            console.log(error)
        }
    }



    return (
        <section>
            <div className="col-12 main-pd">
                <div className="dis-section">
                    <div className="content-sec">
                        <h1 className="t-600">{diseaseInfo?.title || ''}</h1>
                        <div className="content">{parse(`${diseaseInfo?.description || ''}`)}
                        </div>
                        {showReadMore && <span className='mt-3'>
                            {parse(`${diseaseDisc}`)}
                        </span>}
                        {!showReadMore && <button className="read-more" onClick={() => { setshowReadMore(true) }}>Read More</button>}
                    </div>
                    <div className="dis-im">
                        <img src={disimIcon} alt="" />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default TreatmentHead
